import * as React from 'react';
import { FloatingPortal } from '@floating-ui/react-dom-interactions';
const TooltipBase = ({ 
/**
  A base Tooltip component for shared functionality
**/
content, offset: _offset = 0, hideArrow = false, open, children, floatingProps, arrowProps, }) => {
    return (React.createElement(React.Fragment, null,
        children,
        React.createElement(FloatingPortal, null, content && open && (React.createElement("div", { ...floatingProps },
            content,
            !hideArrow && React.createElement("div", { ...arrowProps }))))));
};
export default TooltipBase;
//# sourceMappingURL=TooltipBase.js.map